import { render, staticRenderFns } from "./WarehouseItemForm.vue?vue&type=template&id=5fba782d"
import script from "./WarehouseItemForm.vue?vue&type=script&lang=js"
export * from "./WarehouseItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports